import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

function PrivacySection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mb-12">
      <h2
        className="mb-4 text-gray-900"
        style={{
          fontFamily: 'Cormorant Garamond, serif',
          fontWeight: 500,
          fontSize: '22px',
        }}
      >
        {title}
      </h2>
      <div
        className="text-sm text-gray-600 leading-relaxed space-y-3"
        style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
      >
        {children}
      </div>
    </div>
  );
}

export default function Privacy() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <main className="flex-1 pt-24">
        {/* Header */}
        <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20 border-b border-gray-100">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-px bg-gray-300" />
            <span
              className="text-xs tracking-widest uppercase text-gray-400"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Données personnelles
            </span>
          </div>
          <h1
            className="text-gray-900"
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontWeight: 300,
              fontSize: 'clamp(32px, 4vw, 56px)',
              lineHeight: '1.1',
            }}
          >
            Politique de <em style={{ fontStyle: 'italic' }}>confidentialité</em>
          </h1>
          <p
            className="mt-4 text-sm text-gray-400"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Dernière mise à jour : mars 2026
          </p>
        </div>

        {/* Content */}
        <div className="px-6 md:px-10 lg:px-16 py-16 md:py-24">
          <div className="max-w-3xl">

            <PrivacySection title="1. Responsable du traitement">
              <p>
                Le responsable du traitement des données personnelles collectées sur ce site est :<br />
                <strong className="font-medium text-gray-800">WABICH – Joanna Maria Wabich</strong><br />
                91 Rue Nationale, 59800 Lille, France<br />
                Email : joannawab1ch@outlook.com
              </p>
            </PrivacySection>

            <PrivacySection title="2. Données collectées">
              <p>
                Dans le cadre de l&apos;utilisation de ce site, notamment via le formulaire de contact, les données personnelles suivantes peuvent être collectées :
              </p>
              <ul className="list-disc list-inside space-y-1 pl-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Message / description du projet</li>
              </ul>
            </PrivacySection>

            <PrivacySection title="3. Finalité de la collecte">
              <p>
                Les données collectées via le formulaire de contact sont utilisées exclusivement pour :
              </p>
              <ul className="list-disc list-inside space-y-1 pl-2">
                <li>Répondre aux demandes de renseignement et de devis</li>
                <li>Établir une relation professionnelle dans le cadre des services de design proposés</li>
              </ul>
              <p>
                Aucune donnée n&apos;est utilisée à des fins commerciales ou publicitaires sans consentement explicite.
              </p>
            </PrivacySection>

            <PrivacySection title="4. Conservation des données">
              <p>
                Les données personnelles sont conservées pendant la durée nécessaire à la gestion de la relation client et dans le respect des obligations légales en vigueur, sans dépasser 3 ans à compter du dernier contact.
              </p>
            </PrivacySection>

            <PrivacySection title="5. Partage des données">
              <p>
                WABICH s&apos;engage à ne jamais vendre, louer, céder ou donner accès à vos données personnelles à des tiers, sauf obligation légale.
              </p>
              <p>
                Vos données ne sont pas partagées avec des sociétés tierces à des fins de marketing ou de prospection.
              </p>
            </PrivacySection>

            <PrivacySection title="6. Vos droits (RGPD)">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside space-y-1 pl-2">
                <li>Droit d&apos;accès à vos données personnelles</li>
                <li>Droit de rectification en cas d&apos;inexactitude</li>
                <li>Droit à l&apos;effacement (droit à l&apos;oubli)</li>
                <li>Droit d&apos;opposition au traitement</li>
                <li>Droit à la portabilité des données</li>
              </ul>
              <p>
                Pour exercer ces droits, contactez-nous à :{' '}
                <a
                  href="mailto:joannawab1ch@outlook.com"
                  className="text-gray-800 underline underline-offset-2 hover:text-gray-900 cursor-pointer"
                >
                  joannawab1ch@outlook.com
                </a>
              </p>
            </PrivacySection>

            <PrivacySection title="7. Cookies">
              <p>
                Ce site peut utiliser des cookies techniques nécessaires au bon fonctionnement des pages. Ces cookies ne collectent pas de données personnelles et ne sont pas utilisés à des fins publicitaires.
              </p>
            </PrivacySection>

            <PrivacySection title="8. Contact et réclamation">
              <p>
                Pour toute question relative à la protection de vos données personnelles, vous pouvez contacter WABICH à l&apos;adresse email{' '}
                <a
                  href="mailto:joannawab1ch@outlook.com"
                  className="text-gray-800 underline underline-offset-2 hover:text-gray-900 cursor-pointer"
                >
                  joannawab1ch@outlook.com
                </a>
                .
              </p>
              <p>
                En cas de réclamation, vous pouvez également contacter la Commission Nationale de l&apos;Informatique et des Libertés (CNIL) à l&apos;adresse{' '}
                <a
                  href="https://www.cnil.fr"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-800 underline underline-offset-2 hover:text-gray-900 cursor-pointer"
                >
                  www.cnil.fr
                </a>
                .
              </p>
            </PrivacySection>

            <div className="pt-8 border-t border-gray-100 flex flex-col sm:flex-row gap-4">
              <Link
                to="/conditions-generales"
                className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                <i className="ri-arrow-right-line text-base" />
                Conditions générales
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                <i className="ri-arrow-right-line text-base" />
                Nous contacter
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
